<template>
  <v-dialog v-model="openAiInfo" width="450">
    <v-card class="pa-4">
      <v-card-title class="pa-0 ma-0 align-center d-flex justify-space-between">
        <div class="d-flex align-center">
          <span class="text-h5">Disclaimer</span>
        </div>
        <v-btn
          size="x-small"
          variant="text"
          icon
          color="grey"
          @click="openAiInfo = false"
        >
          <v-icon >mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <p class="mt-6">By using our AI Copilot you agree to share data with Open AI. Open AI is committed to building trust by
        protecting customer data, models and products. Open AI only retains data sent through the API for up to 30
        days for abuse and monitoring purposes.</p>
      <p class="mt-6"> <strong>Read more about how Open AI manages customer data here:</strong></p>
      <p class="mt-6"><a href="https://openai.com/policies/privacy-policy" target="_blank">Open AI Privacy policy</a></p>
      <p class="mt-6"><a href="https://openai.com/policies/api-data-usage-policies" target="_blank">Open AI data usage policies</a>
      </p>
      <p class="mt-6"><a href="https://openai.com/security" target="_blank">Open AI security</a></p>
      <v-checkbox class="mt-6" v-model="aiDisclaimerPreference" :label="$route.params.projectId ? 'Don\'t show again for this project' : 'Don\'t show again when creating projects'" />
      <v-card-actions class="pa-0 mt-2 justify-end" style="padding: 0 !important;">
        <v-btn variant="outlined" size="large" @click="openAiInfo = false">Cancel</v-btn>
        <v-btn variant="flat" size="large" @click="saveDisclaimerPreference">{{
          "OK"
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      openAiInfo: false,
      aiDisclaimerPreference: localStorage.getItem(`showAiInfo-${this.$route.params.projectId ? this.$route.params.projectId : 'dashboard'}`) === 'true'
    }
  },
  props: ['open'],
  methods: {
    saveDisclaimerPreference () {
      this.setShowAiInfo(`${this.aiDisclaimerPreference}`)
      this.openAiInfo = false
      this.$emit('conditions-accepted')
    },
    openDialog () {
      if (this.getShowAiInfo()) {
        this.openAiInfo = false
        this.$emit('conditions-accepted')
      } else {
        this.openAiInfo = true
      }
    },
    close () {
      this.openAiInfo = false
      this.$emit('close')
    },
    getShowAiInfo () {
      if (this.$route.params.projectId) {
        return localStorage.getItem(`showAiInfo-${this.$route.params.projectId}`) === 'true'
      } else {
        return localStorage.getItem('showAiInfo-dashboard') === 'true'
      }
    },
    setShowAiInfo (value) {
      if (this.$route.params.projectId) {
        localStorage.setItem(`showAiInfo-${this.$route.params.projectId}`, value)
      } else {
        localStorage.setItem('showAiInfo-dashboard', value)
      }
    }
  }
}
</script>
